import { useState } from "react";
import { useNavigate } from "react-router-dom";

function GoogleIcon(props) {
  return (
    <svg viewBox="0 0 48 48" className="w-5 h-5" {...props}>
      <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
      <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
      <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
      <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
    </svg>
  );
}

export default function AuthCard() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const isLogin = tab === "login";

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/dashboard");
  };

  return (
    <div className="bg-[#FCFBFE]  flex justify-start gap-36 pt-6   ">
      {/* Illustration Section */}
      <div className=" ">
        <img
          src="/img/blog/loging.svg"
          alt="Write your travel story"
          className="w-full h-[500px] "
        />
      </div>

      {/* Form Section */}
      <div className=" flex flex-col items-center lg:items-center text-center lg:text-center">
        <div className="mb-6">
          <p className="text-base  text-center font-medium text-slate-900 mb-1">Welcome! 👋</p>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 leading-snug mb-2">
            Start Sharing your{" "}
            <span className="text-[#7209B7]">Travel Stories</span>
          </h1>
          <p className="text-sm text-slate-500 leading-relaxed max-w-md">
            Login or create an account to write blogs, share tips and inspire travelers.
          </p>
        </div>

        <div className="w-full max-w-[400px]">
          {/* Tab Switcher */}
          <div className="flex bg-slate-100 rounded-[12px] p-1 mb-6">
            <button
              type="button"
              onClick={() => setTab("login")}
              className={`flex-1 py-2.5 rounded-[12px] text-sm font-semibold transition-all duration-200 ${
                isLogin ? "bg-white text-[#7209B7] shadow-sm" : "text-slate-400 hover:text-slate-600"
              }`}
            >
              Login
            </button>
            <button
              type="button"
              onClick={() => setTab("signup")}
              className={`flex-1 py-2.5 rounded-[12px] text-sm font-semibold transition-all duration-200 ${
                !isLogin ? "bg-white text-[#7209B7] shadow-sm" : "text-slate-400 hover:text-slate-600"
              }`}
            >
              Sign up
            </button>
          </div>

          {/* Form Fields */}
          <form onSubmit={handleSubmit} className="flex flex-col gap-3.5">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your Email Address"
              className="w-full bg-slate-100 rounded-[12px] px-4 py-3 text-sm text-slate-700 placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-[#7209B7]/30 transition-all"
            />
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your Email Password"
              className="w-full bg-slate-100 rounded-[12px] px-4 py-3 text-sm text-slate-700 placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-[#7209B7]/30 transition-all"
            />
            <button
              type="submit"
              className="w-full bg-[#7209B7] text-white font-semibold text-sm py-3 rounded-[12px] hover:bg-[#5a07a0] active:scale-[0.98] transition-all duration-200 mt-1  "
            >
              {isLogin ? "Login" : "Sign up"}
            </button>
          </form>

          {/* Divider */}
          <div className="flex items-center gap-3 my-5">
            <span className="flex-1 h-px bg-slate-200" />
            <span className="text-xs text-slate-400">or</span>
            <span className="flex-1 h-px bg-slate-200" />
          </div>

          {/* Google Button */}
          <button
            type="button"
            onClick={() => navigate("/dashboard")}
            className="w-full flex items-center justify-center gap-2.5 border border-slate-200 rounded-xl py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 active:scale-[0.98] transition-all duration-200"
          >
            <GoogleIcon />
            {isLogin ? "Login with Google" : "Sign up with Google"}
          </button>
        </div>
      </div>
    </div>
  );
}